export const NodeLabels = (node: any) => {
  if (!node || !node.node) {
    return null;
  }
  // console.log("node:", node);
  return (
    <>
      {/* <div>
            <span className="label">Associated_gene:</span>
            <span className="value">{node.node['associated_gene']}</span>
          </div> */}

      {Object.keys(node.node)
        .filter((key: string) => key !== "id" && node.node[key] !== "")
        .map((key: string) => (
          <div key={key} style={{ paddingTop: "8px" }}>
            {/* width: '200px', display: 'inline-block'  style={{ fontWeight: 700 }} */}
            <span className="label">{key}:</span>
            <span className="value" style={{ paddingLeft: "8px" }}>
              {node.node[key]}
            </span>
          </div>
        ))}
    </>
  );
};
